import LabelBox from './LabelBox';

export type { LabelBoxProps } from './LabelBox';

export default LabelBox;
